/**
 * 兼容最小最大值
 * @param minCoordinate
 * @param maxCoordinate
 * @param padding
 * @returns {[*,*,*,*]}
 */
export const computeMinMax = (minCoordinate, maxCoordinate, padding) => {
    if (padding) {
        if (Array.isArray(padding)) {
            if (padding.length === 2) {
                minCoordinate[0] = minCoordinate[0] - padding[0];
                maxCoordinate[0] = maxCoordinate[0] + padding[0];

                minCoordinate[1] = minCoordinate[1] - padding[1];
                maxCoordinate[1] = maxCoordinate[1] + padding[1];
            } else if (padding.length === 4) {
                maxCoordinate[0] = maxCoordinate[0] + padding[0];
                maxCoordinate[1] = maxCoordinate[1] + padding[1];

                minCoordinate[1] = minCoordinate[1] - padding[2];
                minCoordinate[0] = minCoordinate[0] - padding[3];

            }
        } else {
            maxCoordinate[0] = maxCoordinate[0] + padding;
            minCoordinate[0] = minCoordinate[0] - padding;

            maxCoordinate[1] = maxCoordinate[1] + padding;
            minCoordinate[1] = minCoordinate[1] - padding;
        }
    }


    return [minCoordinate[0], minCoordinate[1], maxCoordinate[0], maxCoordinate[1]]
}

const getPaddingByUnit = (padding, unit) => {
    if (unit === 'px') {
        // 将像素值转换为度
        const pixelToDegreeConversionFactor = 1 / 111000; // 1 度大约等于 111000 像素
        padding = padding * pixelToDegreeConversionFactor;

    } else if (unit === 'm') {
        // 将 padding 值从米转换为度
        padding = padding / 111000; // 1 度大约等于 111000 米
    }

    return padding
}

const transformPaddingByUnit = (padding, unit) => {
    if (padding) {
        if (Array.isArray(padding)) {
            padding = padding.map(item => getPaddingByUnit(item, unit))
        } else {
            padding = getPaddingByUnit(padding, unit)
        }
    }

    return padding
}

/**
 * 获取边界
 * @param coordinates
 * @param options
 * @returns {[*,*,*,*]}
 */
export const getBox = (coordinates, options) => {
    // 找到最小的经度和纬度值
    let minCoordinate = [];
    let maxCoordinate = [];

    coordinates.forEach((c, index) => {
        let i = index%2;
        if (i === 0) {
            if (minCoordinate[0] === undefined || c < minCoordinate[0]) {
                minCoordinate[0] = c;
            }

            if (maxCoordinate[0] === undefined || c > maxCoordinate[0]) {
                maxCoordinate[0] = c;
            }
        } else if (i === 1) {
            if (minCoordinate[1] === undefined || c < minCoordinate[1]) {
                minCoordinate[1] = c;
            }

            if (maxCoordinate[1] === undefined || c > maxCoordinate[1]) {
                maxCoordinate[1] = c;
            }
        }
    })

    if (options) {
        let {padding, unit} = options;

        return computeMinMax(minCoordinate, maxCoordinate, transformPaddingByUnit(padding, unit))
    }

    return [minCoordinate[0], minCoordinate[1], maxCoordinate[0], maxCoordinate[1]];
}

export default (geoJson, options) => {
    const coordinates = [];

    geoJson.features.map(feature => {
        let c = feature.geometry.coordinates.flat(Infinity);
        coordinates.push(...c)
    });

    return getBox(coordinates, options)
}
